import React from 'react';
import {Orders, Products} from 'api';
import {LoadingPage} from 'components/loading-page';
import {DateTime} from 'components/UI/DateTime';
import {toastr} from 'react-redux-toastr';
import {withRouter} from 'react-router-dom';
import {UploadImage} from 'components/UI/Image';
import {numberFormat} from 'components/utils';
import {ShowIf} from 'components/utils';
import {getPrice} from 'lib/convert';

const ORDER_STATUSES = {
  AWAITING: 0,
  FORWARED: 1,
  CANCELED: 2,
  FINISHED: 3,
};

class OrderHistoryDetailContent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: null,
      orderInfo: null,
      totalPrice: 0,
      isLoading: false
    };
  }

  componentDidMount() {
    if (this.props.params && this.props.params.id) {
      let params = {
        id: this.props.params.id,
        filter: {
          include: {
            orderBusinesses: [
              'business',
              {orderDetails: 'product'}
            ]
          }
        }
      };
      this.setState({isLoading: true});
      Orders.actions.order.request(params).then(response => {
        let orderBusinesses = [];
        let totalPrice = 0;
        let orderInfo = {};
        if (response.data) {
          orderInfo = {
            name: response.data.customerName,
            phone: response.data.customerPhone,
            status: response.data.status
          };
          orderBusinesses = response.data.orderBusinesses || [];
          totalPrice = response.data.amount;
        }
        let orderData = orderBusinesses.map(orderBusiness => {
          let products = [];
          if (orderBusiness && orderBusiness.orderDetails) {
            products = orderBusiness.orderDetails.map(orderDetail => ({
              ...orderDetail.product,
              quantity: orderDetail.quantity,
              orderPrice: orderDetail.price,
            }));
          }
          let newOrderBusiness = {
            products,
            business: orderBusiness.business,
            status: orderBusiness.status,
            createdAt: orderBusiness.createdAt,
            updatedAt: orderBusiness.updatedAt,
          };
          return newOrderBusiness;
        });
        this.setState({
          orderInfo,
          orderData,
          totalPrice,
          isLoading: false,
        });
      }).catch((error) => {
        this.setState({isLoading: false});
        this.props.history.push('/my-business/orders');
        toastr.error('Lỗi!', 'Không tìm thấy đơn hàng này.');
      });
    }
  }

  render() {
    if (!this.state.orderData) {
      return null;
    }
    return (
      <div className="shopping-cart-container">
        <LoadingPage isShow={this.state.isLoading} />
        <div className='shopping-cart-content'>
          <div className='table-list-item-shopping'>
            <div className='table-list-item-header'>
              <p className='table-list-item-header-content'>Thông tin người đặt hàng</p>
            </div>
            <div className='table-list-item-body'>
              <div className="item-shopping">
                <p className='item-shopping-name'><strong>Họ tên</strong>: {this.state.orderInfo.name}</p>
              </div>
              <div className="item-shopping">
                <p className='item-shopping-name'><strong>Số điện thoại</strong>: {this.state.orderInfo.phone}</p>
              </div>
            </div>
          </div>
          <div className='shopping-order-container mb10'>
            <div className='content-justify mb5'>
              <p className='shopping-order-title'>Tổng tiền</p>
              <p className='shopping-order-content-red'>{getPrice(this.state.totalPrice)}</p>
            </div>
            <p className='shopping-order-content-desc'>(Đã bao gồm VAT)</p>
          </div>
          { this.state.orderData.map((item, idx) => (
              <div className="fair-box-order table-responsive">
                <p className="text name">
                  <strong>Doanh nghiệp: </strong>
                  {item.business && item.business.name}
                </p>
                <p className="text">
                  <strong>Địa chỉ: </strong>
                  {item.business && item.business.address}
                </p>
                <p className="text">
                  <strong>Số điện thoại: </strong>
                  {item.business && item.business.phone}
                </p>
                <p className="status-text">
                  <strong>Trạng thái: &nbsp;</strong>
                  <ShowIf condition={item.status === ORDER_STATUSES.AWAITING}>
                    <span className="larger label-primary">Đang tiếp nhận</span>
                  </ShowIf>
                  <ShowIf condition={item.status === ORDER_STATUSES.FORWARED}>
                    <span className="larger label-primary">Đang xử lý</span>
                  </ShowIf>
                  <ShowIf condition={item.status === ORDER_STATUSES.FINISHED}>
                    <span className="larger label-success">Đã kết thúc</span>
                  </ShowIf>
                  <ShowIf condition={item.status === ORDER_STATUSES.CANCEL}>
                    <span className="larger label-danger">Đã hủy</span>
                  </ShowIf>
                </p>
                <table className="table table-striped col-lg-6">
                  <thead>
                    <tr>
                      <th className="cell-small text-center">#</th>
                      <th className="cell-large text-center">Hình sản phẩm</th>
                      <th className="cell-large text-center">Thông tin sản phẩm</th>
                      <th className="cell-medium text-right">Đơn giá</th>
                      <th className="cell-normal text-right">Số lượng</th>
                      <th className="cell-medium text-right">Thành tiền</th>
                    </tr>
                  </thead>
                  <tbody>
                    { item.products && item.products.map((product, index) => (
                      <tr key={product.id}>
                        <td className="text-center">{index + 1}</td>
                        <td className="text-center wrap-image-table">
                          <UploadImage type="PRODUCT" width="auto" height="auto" image={product.images[product.images.length -1]} />
                        </td>
                        <td className="text-center">
                          <span style={{fontWeight: 'bold'}}>{product.name}</span>
                        </td>
                        <td className="text-right">{getPrice(product.orderPrice)}</td>
                        <td className="text-center">{product.quantity}</td>
                        <td className="text-right">{getPrice((product.orderPrice * product.quantity))}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))
          }
        </div>
      </div>
    );
  }
}

export default withRouter(OrderHistoryDetailContent);



// WEBPACK FOOTER //
// ./components/users/sub-view/order-history-content/OrderHistoryDetailContent.jsx